export default __webpack_public_path__ + "static/media/madrona.dc787533.png";